const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
const mobileViewport = window.matchMedia('(max-width: 749px)');

const initialiseHero = (hero) => {
  if (hero.dataset.videoInitialised === 'true') return;
  hero.dataset.videoInitialised = 'true';
  const video = hero.querySelector('.wa2-hero__video');
  if (!video || reducedMotion.matches) return;
  const source = mobileViewport.matches ? video.dataset.mobileSrc : video.dataset.desktopSrc;
  if (!source) return;

  video.src = source;
  video.addEventListener('canplay', () => video.classList.add('is-ready'), { once: true });
  if (video.dataset.autoplay === 'true') video.play().catch(() => {});
  if (hero.dataset.scrollEffect !== 'true') return;

  let queued = false;
  const update = () => {
    queued = false;
    const rect = hero.getBoundingClientRect();
    const progress = Math.min(1, Math.max(0, -rect.top / Math.max(rect.height, 1)));
    hero.style.setProperty('--wa2-hero-scroll', progress.toFixed(3));
  };
  const onScroll = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(update);
  };
  update();
  window.addEventListener('scroll', onScroll, { passive: true });
};

document.querySelectorAll('[data-wa-video-hero]').forEach(initialiseHero);
document.addEventListener('shopify:section:load', (event) => {
  event.target.querySelectorAll('[data-wa-video-hero]').forEach(initialiseHero);
});
